import { BranchesOutlined } from '@ant-design/icons';
import { useController } from '@framework/form/hooks/useController.ts';
import { Drawer } from '@framework/ui/components/drawer/Drawer.tsx';
import { Button, type ButtonProps, Space } from 'antd';
import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { type IReference } from '../../../schema/expressions/references/IReference.ts';
import { ConditionGroupExpressionSchema } from '../../../schema/expressions/repository/condition-group/ConditionGroupExpressionSchema.ts';
import { type IConditionGroupExpression } from '../../../schema/expressions/repository/condition-group/IConditionGroupExpression.ts';
import { ConditionGroupInput } from '../../../schema/expressions/repository/condition-group/input/ConditionGroupInput.tsx';
import { DrawerButtonRow } from '../../../ui/drawer/DrawerButtonRow.tsx';

export interface IConditionsEditorInputProps {
  name: string;
  references: IReference[];
  size?: ButtonProps['size'];
}

export function ConditionsEditorInput(props: IConditionsEditorInputProps) {
  const { name, references, size } = props;
  const [isOpen, setIsOpen] = useState(false);

  const methods = useFormContext();
  const { field } = useController(name, { defaultValue: null });

  const value = useWatch({ name }) as IConditionGroupExpression | null;

  return (
    <>
      <Button
        size={size}
        type={value != null ? 'primary' : 'default'}
        icon={<BranchesOutlined />}
        onClick={() => {
          // Inizializziamo l'espressione, perché premendo sul tasto regole
          // senza aver mai aperto il drawer, il valore è null.
          // In questo modo facciamo corrispondere l'apertura del drawer
          // alla valorizzazione del campo.
          if (value == null) {
            field.onChange(
              ConditionGroupExpressionSchema.cast({}, { assert: false }),
            );
          }

          setIsOpen(true);
        }}
      >
        Regole
      </Button>
      <Drawer
        title="Regole di visualizzazione"
        size="large"
        placement="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        {value != null && (
          <ConditionGroupInput name={name} references={references} />
        )}
        <DrawerButtonRow>
          <Space>
            <Button
              size="large"
              danger
              onClick={() => {
                field.onChange(null);
                field.onBlur();
                setIsOpen(false);
              }}
            >
              Rimuovi
            </Button>
            <Button
              size="large"
              type="primary"
              onClick={async () => {
                // Permette di validare il form prima di chiudere il drawer,
                // in modo da mostrare gli errori.
                const isValid = await methods.trigger(name, {
                  shouldFocus: true,
                });

                if (isValid) {
                  setIsOpen(false);
                }
              }}
            >
              Applica
            </Button>
          </Space>
        </DrawerButtonRow>
      </Drawer>
    </>
  );
}
